import React from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import Icons from "components/CustomIcons";

function Loading({ darkMode, t }) {
  return (
    <>
      <style>
        {`
          @keyframes analyticsLoadingSpin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      <MDBox
        style={{
          border: darkMode ? "1px solid #26304b" : "1px solid #e5e7eb",
          background: darkMode ? "#26304b" : "#ffffff",
          borderRadius: 14,
          padding: "14px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 10,
          minHeight: 56,
        }}
      >
        <MDBox
          style={{
            display: "inline-flex",
            animation: "analyticsLoadingSpin 1s linear infinite",
            transformOrigin: "50% 50%",
            lineHeight: 0,
          }}
        >
          <Icons name="Autorenew" size={35} color={darkMode ? "#f8fafc" : "#0f172a"} />
        </MDBox>

        <MDBox style={{ fontSize: 20, fontWeight: 500, color: darkMode ? "#f8fafc" : "#0f172a" }}>
          {t("loading")}
        </MDBox>
      </MDBox>
    </>
  );
}

Loading.propTypes = {
  darkMode: PropTypes.bool,
  t: PropTypes.func,
};

Loading.defaultProps = {
  darkMode: false,
  t: () => {},
};

export default Loading;
